import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from '../layouts/Main';
import { SideCategoryMenu } from '../components';
import {
    Header,
    Footer,
    WelcomeSellBox,
    BreadCrumbBlock,
    RepeatingPostItem,
} from '../components';
import { Helmet } from 'react-helmet';

const SubCategoryTemplate = ({ data, pageContext, location, uri, country_code }) => {
    // let's find a localize content
    // if no localize content, then default to english
    // console.log(pageContext);
    const locale_content = data.mb.category.localizations.find(item => item.locale === pageContext.locale);
    country_code = country_code ? country_code : "us";
    return (
        <Layout>
            <Helmet htmlAttributes={{ lang: `${pageContext.language}` }}>
                <meta content={`https://www.freeconferencecall.com${uri}`} property="og:url" />
                <link rel="canonical" href={`https://www.freeconferencecall.com${uri.replace(`${country_code}/`, '')}`} />
                {
                    pageContext.metadata?.map(item => (
                        <meta key={item.id} name={item.name} content={item.content} />
                    ))
                }
            </Helmet>
            <Header intl={pageContext.intl} categories={data.mb.categories} country_code={country_code} />
            <WelcomeSellBox country_code={country_code} />
            <BreadCrumbBlock location={location} label={locale_content?.name || pageContext.name} subcategories={pageContext.subcategories} categories={pageContext.categories} />
            <div className="block-sm subcategories-results">
                <div className="container">
                    <div className="row">
                        {/* Side Categories menu */}
                        <div className="col-sm-3">
                            <SideCategoryMenu categories={data?.mb?.menu_categories} country_code={country_code} langKey={pageContext.locale} />
                        </div>
                        <div className="col-md-9">
                            <h1 className="section-title">{locale_content?.name || pageContext.name}</h1>
                            {data.mb.posts ? (
                                <>
                                    {data.mb.posts.map(post => {
                                        const localize_post = post.localizations.find(item => item.locale === pageContext.locale) || post;
                                        return <RepeatingPostItem key={localize_post.id} post={localize_post} country_code={country_code} langKey={pageContext.locale} />
                                    }
                                    )}
                                </>
                            )
                                : (
                                    <div className="text-center">
                                        <h2 className="blue">Sorry, nothing found. </h2>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Layout >
    );
};

export default SubCategoryTemplate;

export const pageQuery = graphql`  
query SubCategoriesTemplateQuery($id:ID!, $link: String!, $date: String!, $limit: Int!, $start: Int!, $locale: String!) {
    mb {
        category: subcategory(id:$id){
            id
            link
            name
            metadata {
                id
                name
                content
              }
            locale
            localizations(where: {locale: $locale}) {
                id
                link
                name
                metadata {
                    id
                    name
                    content
                  }
                locale
            }
        }
        posts: blogposts(where: {
                subcategories: {
                    link: $link
                },
                publish_date_lte: $date,
                status: "published"
            }, sort: "publish_date:asc", limit: $limit, start: $start) {
            id
            title
            publish_date
            content
            slug
            locale
            localizations(where: {locale: $locale}) {
                id
                title
                publish_date
                content
                slug
                locale
            }
        }
        categories: categories(where: {in_browse_resources: true}, sort:"index:asc"){
            id
            Name
            link
            external_link
            tag
            index
            icon {
                url
            }
            locale
            localizations(where: {locale: $locale}) {
                id
                Name
                link
                external_link
                tag
                index
                locale
                icon {
                    url
                }
                locale
            }
            subcategories {
                id
                description
                name
                link
                tag
                index
                locale
                localizations(where: {locale: $locale}) {
                    id
                    description
                    name
                    link
                    tag
                    index
                    locale
                }
            }
        }
        menu_categories: categories(where: {in_browse_resources: true}, sort:"index:asc", locale: $locale){
            id
            Name
            index
            link
            external_link
            locale
            localizations(where: {locale: $locale}) {
                id
                Name
                index
                link
                external_link
                locale
            }
        }
    }
}
`;
